// handle to use product : ProductModel
// eslint-disable-next-line
import { BaseCartItemInterface, ProductInterface } from '../cart-item-group/cart-item-group.types';
import { productPlaceholder } from '../../../lib/media';
import { CartItemTypeEnum } from './cart-item-v2.enum';

export const getProductUrl = (product: ProductInterface, isAbsolute: boolean = true) => {
    const createLeadingSlashUrl = (url: string) => {
        if (url?.startsWith('/')) return url;
        return `/${url}`;
    };

    const { url_key, url_suffix, canonical_url } = product;
    let baseUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? '';

    // Check if the base URL ends with a slash and remove it if it does
    if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1);
    }

    let relativeUrl = `${createLeadingSlashUrl(url_key ?? '')}${url_suffix}`;
    if (canonical_url) {
        relativeUrl = createLeadingSlashUrl(canonical_url);
    }

    return isAbsolute ? `${baseUrl}${relativeUrl}` : `${relativeUrl}`;
};

const isConfigurableItem = (item: BaseCartItemInterface) => {
    return (
        item?.__typename === CartItemTypeEnum.CONFIGURABLE || item?.__typename === CartItemTypeEnum.CONFIGURABLE_LOCAL
    );
};

const getProductItemImage = (product: ProductInterface) => {
    const { small_image, small_image_url } = product;
    return small_image?.url ?? small_image_url ?? productPlaceholder;
};

export const getCartItemImage = (item: BaseCartItemInterface) => {
    if (isConfigurableItem(item)) {
        if (!item?.configured_variant) return productPlaceholder;
        return getProductItemImage(item?.configured_variant);
    }

    if (!item?.product) return productPlaceholder;
    return getProductItemImage(item?.product);
};
